/**
 * @param {number|string} value
 * @returns {number}
 */
export const round2 = (value) => Math.round(Number(value) * 100) / 100;

/**
 * Caps a money value to available balance (cent-safe).
 * @param {number|string} value
 * @param {number} balance
 * @returns {number}
 */
export const capToBalance = (value, balance) => {
  if (!(balance > 0)) return 0;

  const rounded = round2(Math.max(Number(value) || 0, 0));

  if (rounded <= balance) return rounded;

  let cents = Math.floor(balance * 100 + 1e-8);

  if (cents / 100 > balance) cents -= 1;

  return Math.max(cents, 0) / 100;
};

/**
 * @param {number|string} value
 * @returns {string}
 */
export const formatRisk = (value) => {
  const numeric = Number(value);

  if (!Number.isFinite(numeric)) return "0.00";

  return numeric.toFixed(2);
};

/**
 * @param {number|string} value
 * @returns {string}
 */
export const formatUsd = (value) => {
  const numeric = Number(value);

  if (!Number.isFinite(numeric)) return "—";

  return `$${numeric.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/**
 * Keeps digits and at most one decimal point with up to 2 fraction digits.
 * @param {string|number} raw
 * @returns {string}
 */
export const sanitizeAmount = (raw) => {
  const cleaned = String(raw).replace(/,/g, "").replace(/[^\d.]/g, "");
  const dotIndex = cleaned.indexOf(".");

  if (dotIndex === -1) return cleaned;

  const intPart = cleaned.slice(0, dotIndex);
  const decimals = cleaned.slice(dotIndex + 1).replace(/\./g, "").slice(0, 2);

  return `${intPart}.${decimals}`;
};

/**
 * Groups integer part with thousands separators.
 * @param {string|number} raw
 * @returns {string}
 */
export const groupAmount = (raw) => {
  if (!raw) return "";

  const [intPart, decPart] = String(raw).split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return decPart != null ? `${grouped}.${decPart}` : grouped;
};

/**
 * @param {string} draft
 * @returns {number}
 */
export const draftToNumber = (draft) => {
  if (draft === "" || draft === ".") return 0;

  const numeric = Number(draft);

  return Number.isFinite(numeric) ? numeric : 0;
};

/**
 * Width in `ch` units for auto-sized inputs.
 * @param {string|number} value
 * @param {string} [fallback]
 * @returns {string}
 */
export const fieldWidth = (value, fallback = "1") => {
  const text = String(value || fallback);

  return `${Math.max(text.length, 1)}ch`;
};
